var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4618 17.0001H11.2546C10.9574 17.0001 10.7162 16.7517 10.7162 16.4457C10.7162 16.1397 10.9574 15.8913 11.2546 15.8913H16.4618C16.759 15.8913 17.0002 16.1397 17.0002 16.4457C17.0002 16.7517 16.759 17.0001 16.4618 17.0001Z",
    fill: "#2B3D5B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 13,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00024 3.00012H15.3347V17.0001H3.00024V3.00012Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_623)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9766 4.49087L4.21727 13.1949C4.0945 13.3531 4.04927 13.5571 4.0945 13.753L4.58341 15.8855L6.7652 15.8575C6.97269 15.8552 7.16437 15.7599 7.29145 15.5973C9.60103 12.622 14.0041 6.94943 14.129 6.78311C14.2468 6.58649 14.2927 6.30855 14.231 6.04096C14.1678 5.76672 14.002 5.53387 13.7629 5.3853C13.7119 5.34907 12.5022 4.38221 12.4649 4.3519C12.0097 3.97639 11.3456 4.04144 10.9766 4.49087ZM4.15846 17.0002C3.90934 17.0002 3.69253 16.8243 3.63437 16.5737L3.04639 14.0079C2.92506 13.4765 3.04567 12.928 3.37664 12.5022L10.1395 3.79301C10.1424 3.79006 10.1446 3.78636 10.1474 3.7834C10.8891 2.8705 12.2302 2.73597 13.1348 3.48329C13.1707 3.51212 14.3718 4.47307 14.3718 4.47307C14.8083 4.74066 15.1493 5.21892 15.2785 5.78514C15.407 6.34545 15.3137 6.9235 15.0143 7.41211C14.992 7.44833 14.9727 7.47937 8.13221 16.2906C7.80268 16.7134 7.30875 16.9595 6.7782 16.9662L4.16564 17.0002H4.15846Z",
    fill: "#2B3D5B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2115 9.41973C13.0966 9.41973 12.9817 9.38203 12.8834 9.30516L8.96922 6.20941C8.73374 6.02313 8.68923 5.67571 8.87014 5.43178C9.05178 5.18932 9.38921 5.14423 9.62541 5.33051L13.5403 8.42551C13.7758 8.61179 13.8203 8.95995 13.6386 9.20315C13.5331 9.34507 13.373 9.41973 13.2115 9.41973Z",
    fill: "#2B3D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.23378e67825f42ad7ed7264f30e42923.svg";
export { ForwardRef as ReactComponent };